import {
    FETCH_VERIFIED_START,
    FETCH_VERIFIED_SUCCESS,
    FETCH_VERIFIED_ERROR,
    SET_MRT_VERIFIED_FILTER,
    SET_VERIFIED_PAGINATION,

    VIEW_VERIFIED_VISIT_LOADING_START,
    VIEW_VERIFIED_VISIT_LOADING_END,
    RESET_VERIFIED_FILTER

} from '../../actions/mrt/verifiedAction';

import {
    VIEW_VERIFIED_VISIT_SUCCESS
} from "../../actions/mrt/reportViewerAction";
import { paginationSize } from '../../../constants/constants';
import _ from 'lodash';

const INIT_STATE = {
    error: "",
    loading: false,
    message: '',
    pagination: {
        currentPage: 1,
        pageSize: paginationSize,
        totalPages: 0,
        totalItems: 0,
    },
    verified: [],
    autoNextVisit: false,
    searchFilter: {
        searchText: "",
        risId: 1,
        mipIds: [],
        modalityIds: [],
        startDate: null,
        endDate: null,
    },
    sortConditions: [{ sortBy: "priority", dataType: "STRING", sortType: "desc" }],
    skippedVisits: []
};

const verifiedReducer = (state = INIT_STATE, action) => {
    let newState;
    let index;
    switch (action.type) {
        case FETCH_VERIFIED_START:
        case VIEW_VERIFIED_VISIT_LOADING_START: {
            return { ...state, error: '', message: '', loading: true };
        }
        case FETCH_VERIFIED_SUCCESS: {
            return { ...state, error: '', message: '', loading: false, verified: action.verified };
        }
        case FETCH_VERIFIED_ERROR: {
            return { ...state, loading: false, error: action.error, message: '' };
        }
        case VIEW_VERIFIED_VISIT_SUCCESS: {
            return { ...state, error: '', message: '' };
        }
        case SET_MRT_VERIFIED_FILTER: {
            newState = { ...state };
            newState.searchFilter = { ...action.payload.searchFilter }
            newState.sortConditions = action.payload.sortConditions.length > 0 ? [...action.payload.sortConditions] : []
            newState.skippedVisits = action.payload.skippedVisits.length > 0 ? [...action.payload.skippedVisits] : []
            return {
                ...newState
            }
        }

        case SET_VERIFIED_PAGINATION: {
            return { ...state, pagination: action.pagination };
        }

        case VIEW_VERIFIED_VISIT_LOADING_END: {
            return { ...state, loading: false };
        }

        case RESET_VERIFIED_FILTER: {
            newState = _.cloneDeep(state);
            newState.searchFilter.searchText = null;
            newState.searchFilter.startDate = null;
            newState.searchFilter.endDate = null;
            return { ...newState };
        }
        default:
            return state;
    }
}

export default verifiedReducer;
